export default {
  listTitle: 'Счета',
  detailTitle: 'Счёт',
  empty: 'Счета не найдены',
  transactionsEmpty: 'Транзакции не найдены',
  operationsEmpty: 'Операции не найдены',
  currentAccount: 'current',
  tabs: {
    transactions: 'Транзакции',
    operations: 'Операции',
  },
  directions: {
    debit: 'списание',
    credit: 'пополнение',
    out: 'списание',
    in: 'пополнение',
  },
  transactionColumns: {
    id: 'ID',
    amount: 'Сумма',
    description: 'Описание',
    fromAccountId: 'From AcID',
    direction: 'Направление',
    toAccountId: 'To AcID',
  },
  operationColumns: {
    createdAt: 'Дата',
    type: 'Тип',
    status: 'Статус',
    description: 'Описание',
    orderId: 'Заказ',
    amount: 'Сумма',
    currency: 'Валюта',
    details: 'Подробно',
  },
  columns: {
    id: 'ID',
    balance: 'Баланс',
    currency: 'Валюта',
    type: 'Тип',
    walletId: 'Кошелёк',
    userId: 'User ID',
    description: 'Описание',
    details: 'Подробно',
    createdAt: 'Создан',
  },
  types: {
    user: 'Пользователь',
    restorant: 'Ресторан',
    courier: 'Курьер',
    service: 'Сервис',
    fund: 'Фонд',
    partner: 'Партнёр',
    freeze: 'Заморозка',
    virtual: 'Виртуальный',
  },
  filters: {
    accountIdPlaceholder: 'ID счёта',
    walletIdPlaceholder: 'ID кошелька',
    userIdPlaceholder: 'User ID',
    typePlaceholder: 'Тип',
    currencyAll: 'Все валюты',
    reset: 'Сбросить',
  },
  actions: {
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
    openFilteredList: 'Открыть список с фильтром',
    openDetails: 'Подробнее',
    openDetailsNewWindow: 'Открыть в новом окне',
    openWallet: 'Открыть кошелёк',
    openWalletNewWindow: 'Открыть кошелёк в новом окне',
    deposit: 'Пополнить',
    withdraw: 'Списать',
    exchange: 'Обмен',
  },
  modals: {
    depositTitle: 'Пополнить',
    withdrawTitle: 'Списать',
    exchangeTitle: 'Обмен',
    amount: 'Сумма',
    description: 'Описание',
    orderId: 'ID заказа (необязательно)',
    currency: 'Валюта',
    toAccount: 'Куда',
    exchangeRate: 'Курс',
    exchangeRateSource: 'Источник курса',
    exchangePreview: 'Получите ≈ {amount} {currency}',
    depositSubmit: 'Пополнить',
    withdrawSubmit: 'Списать',
    exchangeSubmit: 'Обменять',
    depositSuccess: 'Счёт пополнен',
    withdrawSuccess: 'Списание выполнено',
    exchangeSuccess: 'Обмен выполнен',
    depositDescriptionPlaceholder: 'Ручное пополнение',
    withdrawDescriptionPlaceholder: 'Ручное списание',
    exchangeDescriptionPlaceholder: 'Обмен валют',
    toAccountOption: '{currency} · {balance}',
  },
  validation: {
    amountRequired: 'Укажите сумму больше 0',
    descriptionRequired: 'Укажите описание',
    descriptionTooLong: 'Описание не длиннее 500 символов',
    toAccountRequired: 'Выберите счёт',
  },
  apiErrors: {
    generic: 'Не удалось выполнить операцию',
    wallet_validation_error: 'Проверьте поля формы',
    account_invalid_amount: 'Некорректная сумма',
    account_invalid_exchange_rate: 'Некорректный курс',
    no_such_rate: 'Нет курса для выбранной пары валют',
    exchange_same_currency: 'Счета должны быть в разных валютах',
    exchange_different_wallets: 'Счета должны принадлежать одному кошельку',
    account_no_wallet: 'У счёта не найден кошелёк',
    account_no_currency: 'У счёта не указана валюта',
  },
  errors: {
    loadList: 'Не удалось загрузить счета',
    loadDetail: 'Не удалось загрузить счёт',
    loadTransactions: 'Не удалось загрузить транзакции счёта',
    loadOperations: 'Не удалось загрузить операции счёта',
    missingId: 'Не указан ID счёта',
  },
}
